exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#flat-rate-section .expansionHeader {\n  background-color: lightgrey !important; }\n  #flat-rate-section .expansionHeader mat-panel-title, #flat-rate-section .expansionHeader mat-panel-description {\n    font-size: 16px;\n    font-weight: 500; }\n  #flat-rate-section .tableHead {\n  font-size: 16px;\n  font-weight: 600; }\n  #flat-rate-section .costTable {\n  border-collapse: collapse;\n  border-spacing: 0;\n  table-layout: fixed; }\n  #flat-rate-section .costTable thead tr td {\n    font-size: 16px;\n    font-weight: 600; }\n  #flat-rate-section .costTable td {\n    padding: 5px;\n    border: 1px solid;\n    height: 0px; }\n  #flat-rate-section .closeBtn {\n  left: 90%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /vercel/path0/src/app/main/content/apps/common/flat-rate-section/flat-rate-section.component.scss
// module id = ../../../../../src/app/main/content/apps/common/flat-rate-section/flat-rate-section.component.scss
// module chunks = main